export const secureNetworkErrors = {
    ERRSN0000: "Okay",
    ERRSN0001: "Site is already discovered through the Secure Network",
    ERRSN0002: "Active Connection for a Node exists in the Secure Network",
    ERRSN0003: "Internal server error",
    ERRSN0004: "Unknown",
    ERRSN0005: "Invalid Argument"
}

export const formErrorMessages = {
    portNumber: "Invalid port number",
    primaryHubURI: "Invalid URL",
    failoverHubURI: "Invalid URL",
    issuerCertFile: "Invalid file",
    issuerCertificate: "Invalid name",
    issuerCertValidityYear: "Invalid number",
    oprCertValidityYear: "Invalid number",
    operationalCertificateRequest: "No certificate imported",
    InvalidFile: "Only .pem extension files are allowed",
    EmptyprimaryHubURI: "Primary Hub URL is required",
    ConnectionTimeoutDefaultValue: "Enter Connection Timeout from 5 to 300 seconds",
    EmptyConnectionTimeout: "Valid range of Connection Timeout for BACnet Secure connection is from 5 to 300 seconds",
    InvalidPortRange: "Valid Range of Port number is from 1 to 65534",
    EmptyPortNumber: "Port Number is required",
    TlsVersionNumberRange: "TLS Min Version should not be greater than Max Version",
    UniqueHubURL: "Primary and Failover Hub URLs must be different for BACnet Secure Connect", 
    HubValidation: "The Hub for BACnet Secure Connect Link must be configured as either the Primary Hub or Failover Hub.",
    InvalidPrimaryHubURI: "Invalid Primary Hub URL. Must start with 'wss://'.",
    InvalidFailoverHubURI: "Invalid Failover Hub URL. Must start with 'wss://'.",
    EmptyTestConnection: "Enter URL starting with 'wss://'."
};

export const TableRowProps = {
    className: "material-ui-table-body-row",
};

export const TableCellClass = {
    className: "material-ui-table-body-cell",
    scope: "row"
};

export const isEmpty = (data) => {
    if (Array.isArray(data)) {
        return data.length ? true : false;
    } else {
        return Object.keys(data).length ? false : true;
    }
}

export const fileInputFields = ["issuerCertFile", "operationalCertificateRequest"];

export const initialState = () => ({
    editMode: false,
    isFormError: false,
    networkID: 0,
    networkNumber: 0,
    reconnectTime: 10,
    primaryHubURI: "",
    failoverHubURI: "",
    issuerCertFile: "",
    issuerCertificate: "",
    issuerCertificateValidity: "",
    issuerCertValidityYear: "",
    operationalCertificateRequest: "",
    rootCertificateRequest: "",
    oprCertValidityYear: "",
    tlsVersion: { "min": "Tls12", "max": "Tls13" },
    isModelOpen: false,
    selectedCertificate: null,
    selectedFileKey: null,
    isDefaultSort: true,
    primaryURIClassname:"black",
    failoverURIClassname: "black",
    reconnectTimeClassname:"black",
    portClassname:"black",
    tlsVersionClassname: "black",
    useHubAs: "Primary Hub",
    hubMode: 0,
    hubURL: "",
    sort: {
        column: null,
        direction: [
            { name: 'nodeVMAC', direction: 'asc', onclick: true },
            { name: 'deviceID', direction: 'desc', onclick: false },
            { name: 'deviceName', direction: 'desc', onclick: false },
            { name: 'lastConnectedDate', direction: 'desc', onClick: false },
            { name: 'statusDescription', direction: 'desc', onClick: false }

        ]
    },
});

const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptopM: '1374px',
    laptopL: '1440px',
    desktop: '2560px'
}

export const device = {
    mobileS: `(max-width: ${size.mobileS})`,
    mobileM: `(max-width: ${size.mobileM})`,
    mobileL: `(max-width: ${size.mobileL})`,
    tablet: `(max-width: ${size.tablet})`,
    laptop: `(max-width: ${size.laptop})`,
    laptopM: `(max-width: ${size.laptopL})`,
    laptopL: `(max-width: ${size.laptopL})`,
    desktop: `(max-width: ${size.desktop})`,
    desktopL: `(max-width: ${size.desktop})`
};

export const replaceString = (stringValue, start, end, replaceWith) => {
    if (stringValue && stringValue.length) {
        return stringValue.substring(0, start) + replaceWith + stringValue.substring(end);
    } else {
        return "";
    }
}

export const hubDisabledWarning = "BACnet Secure Connect Hub capabilities are disabled or not configured. Please enable to create a BACnet Secure Connect network.";